import React, { useEffect } from 'react';
import styles from './podcast.module.css';
import { PodcastSec } from '../../components';
import { firstPodcastCard, secondPodcastCard } from '../../../constants';
import { podcastBanner, podcastBanner1, podcastBannerMob, podcastBannerMob1 } from '../../../assets';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPodcastData } from '../../slice/podcastSlice';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_EN } from '../../helpers/constant';

const Podcast = () => {

    const dispatch = useDispatch();
    const {data : podcastData, loading, error} = useSelector((state) => state.podcast);
     const { t, i18n } = useTranslation();

    useEffect(() => {
        dispatch(fetchPodcastData());
    },[dispatch]);

    useEffect(() => {
        console.log(' Podcast Data : ', podcastData);
    },[podcastData]);

    
    return (
        <section className={styles.podcastSec}>
            {/* <PodcastSec podCards={firstPodcastCard} banner={podcastBanner} bannerMob={podcastBannerMob} heading="Inspiring stories of business, investment and entrepreneurship in Abu Dhabi" />
            <PodcastSec podCards={secondPodcastCard} banner={podcastBanner1} bannerMob={podcastBannerMob1} /> */}

           {/*  <PodcastSec podCards={firstPodcastCard} banner={podcastBanner} bannerMob={podcastBannerMob} heading="Inspiring stories of business, investment and entrepreneurship in Abu Dhabi" />
            <PodcastSec podCards={secondPodcastCard} banner={podcastBanner1} bannerMob={podcastBannerMob1} /> */}

            {podcastData != null && podcastData.map((data, index) => (
                <PodcastSec 
                    key={index} 
                    podCards={data.episodes} 
                    banner={data.image} 
                    bannerMob={data.podcastMobImage} 
                    //heading={data.title || ""} 
                    heading={i18n.language === LANG_EN ? data.title : data.titleAr || ""}

                />
            ))}
        </section>
    );
};

export default Podcast;
